import {Col, Form} from 'react-bootstrap';
import Select from 'react-select';
import {Controller} from 'react-hook-form';
import stringSimilarity from 'string-similarity';

import {BusinessPartnerContacts} from 'types/api';
import {ariaLiveMessages} from 'constants/reactSelectAriaMessages';
import Label from 'components/ui/Label/Label';
import styles from './ContactInvitePage.module.sass';

interface IProps {
    contacts: BusinessPartnerContacts[];
    handleCreateNew: () => void;
    control: any;
    errors: any;
    inviter?: string;
}

const SelectBusinessPartnerContact: React.FC<IProps> = ({
    contacts,
    control,
    errors,
    handleCreateNew,
    inviter,
}) => {
    const getOptions = () => {
        const connected =
            contacts?.filter(
                contact => contact.connectedBusinessPartner === null,
            ) ?? [];
        const options: BusinessPartnerContacts[] = [];
        if (inviter && connected.length) {
            const names = connected.map(c => c.name);
            const bestMatches = stringSimilarity.findBestMatch(inviter, names);
            bestMatches.ratings.forEach(match => {
                if (match.rating >= 0.9) {
                    const found = connected.find(c => c.name === match.target);
                    if (found) options.push(found);
                }
            });
        }

        return options;
    };
    return (
        <Form.Group as={Col} controlId="contact" xs={12} md={6} lg={4}>
            <Label>
                Please match with one of your beneficiary or{' '}
                <button
                    type="button"
                    className={styles.skipButton}
                    onClick={handleCreateNew}
                >
                    create a new beneficiary
                </button>
            </Label>
            <Controller
                control={control}
                name="contact"
                render={({value, ...restRenderProps}) => {
                    return (
                        <Select
                            {...restRenderProps}
                            ariaLiveMessages={ariaLiveMessages}
                            classNamePrefix="amnis"
                            value={value}
                            options={getOptions()}
                            getOptionValue={option => option['@id']}
                            getOptionLabel={option => option.name}
                            onChange={(event, option) => {
                                control.setValue('contact', event);
                            }}
                        />
                    );
                }}
            />
            {errors.contact ? (
                <Form.Control.Feedback
                    type="invalid"
                    style={{display: 'block'}}
                >
                    {errors.contact.message}
                </Form.Control.Feedback>
            ) : null}
        </Form.Group>
    );
};

export default SelectBusinessPartnerContact;
